export default "__VITE_ASSET__CJ6vt1dA__"